export const toggleMapView = (bool, dispatch) =>
  dispatch({
    type: 'TOGGLE_MAP_VIEW',
    payload: bool,
  });

  export const toggleNotesAndPhotosModal = (bool, dispatch) =>
  dispatch({
    type: 'TOGGLE_NOTES_AND_PHOTOS_MODAL',
    payload: bool,
  });

export const toggleMoveModal = (bool, dispatch) =>
  dispatch({
    type: 'TOGGLE_MOVE_MODAL',
    payload: bool,
  });

export const toggleRespondModal = (bool, dispatch) =>
  dispatch({
    type: 'TOGGLE_RESPOND_MODAL',
    payload: bool,
  });

export const toggleReopenModal = (bool, dispatch) =>
  dispatch({
    type: 'TOGGLE_REOPEN_MODAL',
    payload: bool,
  });

export const toggleBreakInModal = (bool, dispatch) =>
  dispatch({
    type: 'TOGGLE_BREAKIN_MODAL',
    payload: bool,
  });

export const toggleClosedTickets = (bool, dispatch) =>
  dispatch({
    type: 'TOGGLE_CLOSED_TICKETS',
    payload: bool,
  });

export const toggleFolderDrawer = (bool, dispatch) =>
  dispatch({
    type: 'TOGGLE_FOLDER_DRAWER',
    payload: bool,
  });

export const toggleAllTicketsSelected = (bool, dispatch) =>
  dispatch({
    type: 'TOGGLE_ALL_TICKETS_SELECTED',
    payload: bool,
  });

export const toggleOpenClosedButtons = (bool, dispatch) =>
  dispatch({
    type: 'TOGGLE_OPEN_CLOSED_BUTTONS',
    payload: bool,
  });

export const toggleUploadingPhotos = (bool, dispatch) =>
  dispatch({
    type: 'TOGGLE_UPLOADING_PHOTOS',
    payload: bool,
  });
          
